// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.U2CkV3zwFsQssQuPx9xS{align-items:center;min-height:40px;padding:8px 12px 8px 8px}.ceCaOZwTROUbFM_LPyfh{padding-left:4px}.ymQHPtD_sYEzP7mli72k{align-items:center;height:24px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiSelect": `U2CkV3zwFsQssQuPx9xS`,
	"empty": `ceCaOZwTROUbFM_LPyfh`,
	"placeholder": `ymQHPtD_sYEzP7mli72k`
};
export default ___CSS_LOADER_EXPORT___;
